import { render, staticRenderFns } from "./LeadArticle.vue?vue&type=template&id=00a274d8&"
import script from "./LeadArticle.vue?vue&type=script&lang=js&"
export * from "./LeadArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LeadArticle.vue?vue&type=custom&index=0&blockType=styles&scoped=true&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports